import { QuestionTypes } from '@showbie-socrative/socrative-utils';
import { useMutation } from '@tanstack/react-query';
import {
  GenerateQuestionByStudentsParams,
  generateQuestionByStudents,
} from '~api/ai/generateQuestionByStudents';

import { SpecificStudentSelectedQuestionsGeneratedAdapter } from '~analytics/index';

import { countBy } from '../../../../../../shared/src/utils/countBy';

export function useGenerateQuestionsByStudents() {
  return useMutation({
    mutationFn: ({
      activityInstanceId,
      studentIds,
      questionCount,
      generateExplanations,
    }: GenerateQuestionByStudentsParams & {
      numAreasOfImprovement: number;
    }) => {
      return generateQuestionByStudents({
        activityInstanceId,
        studentIds,
        questionCount,
        generateExplanations,
      });
    },
    onSuccess: (
      {
        usage: { promptTokens, completionTokens },
        questions,
        elapsedTime,
        version,
      },
      { studentIds, questionCount, generateExplanations, numAreasOfImprovement }
    ) => {
      // Calculate question type counts
      const {
        MC: numMc = 0,
        TF: numTf = 0,
        FR: numSa = 0,
      } = countBy<{ questionType?: QuestionTypes }, QuestionTypes>({
        items: questions,
        iteratee: (question: { questionType?: QuestionTypes }) =>
          question.questionType,
      });

      // Send analytics
      new SpecificStudentSelectedQuestionsGeneratedAdapter({
        num_areas_of_improvement: numAreasOfImprovement,
        num_students_selected: studentIds.length,
        input_token: promptTokens,
        output_token: completionTokens,
        elapsed_time: elapsedTime,
        generation_version: version,
        generate_explanations: generateExplanations,
        num_mc: numMc,
        num_tf: numTf,
        num_sa: numSa,
        total_questions: questionCount,
      }).sendAnalytics();
    },
  });
}
